module.exports = __webpack_public_path__ + "img/about.230f3505.jpg";